var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleRule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4029 24.8246L26.5122 33.6841L22.5859 29.9645L23.9614 28.5126L26.2871 30.7159L31.8242 23.5967L33.4029 24.8246Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C16 14.3431 17.3431 13 19 13H37C38.6569 13 40 14.3431 40 16V17H42C43.6569 17 45 18.3431 45 20V47C45 48.6569 43.6569 50 42 50H24C22.3431 50 21 48.6569 21 47V45H19C17.3431 45 16 43.6569 16 42V16ZM23 45V47C23 47.5523 23.4477 48 24 48H42C42.5523 48 43 47.5523 43 47V23H40V42C40 43.6569 38.6569 45 37 45H23ZM40 21H43V20C43 19.4477 42.5523 19 42 19H40V21ZM19 15C18.4477 15 18 15.4477 18 16V17H38V16C38 15.4477 37.5523 15 37 15H19ZM38 19H18V42C18 42.5523 18.4477 43 19 43H37C37.5523 43 38 42.5523 38 42V19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleRule);
export default __webpack_public_path__ + "static/media/simple-rule.edc4f36c.svg";
export { ForwardRef as ReactComponent };